/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ w: NonNullable<unknown> }} Wood_LevelInputs */



/**
* | output |
* | --- |
* | "Wood silo ({w}%)" |
*
* @param {Wood_LevelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const wood_level = /** @type {((inputs: Wood_LevelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wood_LevelInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Wood silo (${i?.w}%)`)
	return /** @type {LocalizedString} */ (`Silo bois (${i?.w}%)`)
});